import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
    Layout,
    theme,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    Checkbox,
    Spin,
    Col
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const EditGLA1000 = (props) => {
    //DECLARED VARIABLES
    const { userData } = props;
    const { session } = userData;

    const navigate = useNavigate();
    const { newGLItems, statusData } = appStatic;

    const dispatch = useDispatch();
    const { state } = useLocation();

    const [financialActivityData, setFinancialActivityData] = useState([]);
    const [accountData, setAccountData] = useState([]);
    const [accountingDetail, setAccountingDetail] = useState({});
    const [glDetail, setFundSourceDetail] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [useForm] = Form.useForm();

    useEffect(() => {
        // console.log(useForm);
        // getTemplate();
        getDetailById(state);
        //ACTIVATE SAVE RIGHTSIDEBAR ACTION
        // dispatch({
        //   type: cnt.RIGHT_SAVE_BTN,
        // });
    }, []);

    function onCancel() {
        navigate("/gla1000", { replace: false });
    }

    const getDetailById = (params) => {
        setIsLoading(true);

        const url = `${definedApi.GetFundSourceList}/${params.key}`;

        let body = {
            session,
        };

        /** FETCH ROLE */
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objDetail = res;
                setFundSourceDetail(objDetail);

                // SHOW THE SAVED DATA
                useForm.setFieldsValue({
                    name: objDetail?.name
                });

                setIsLoading(false);
            }
        });
    };


    //   function getTemplate() {
    //     let body = {
    //       session,
    //     };

    //     BOM.FetchReqAction(body, definedApi.GetFundSourceList, (err, res) => {
    //       if (err) {
    //         BOM.AlertMsg(cnt.DANGER, err);
    //       } else {
    //         const objList = res;
    //         let tempFinancialActivity = [];
    //         setAccountingDetail(objList?.glAccountOptions)

    //         // console.log(objList);

    //         objList?.financialActivityOptions?.forEach((element) => {
    //           tempFinancialActivity.push({
    //             value: element.id,
    //             label: element.name,
    //             mappedGLAccountType: element.mappedGLAccountType
    //           });
    //         });

    //         setFinancialActivityData(tempFinancialActivity);

    //       }
    //     });
    //   }

    const onSubmit = (formValues) => {

        const url = `${definedApi.EditFundSource}/${state.key}`;

        const body = {
            ...formValues,
            method: "PUT",
            session,
        };

        // console.log(body);return
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, appLabel.editFundSourceMsg);
                navigate("/gla1000");
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={false}>
            <TopContent
                pageTitle={appLabel.editFundSource}
                pageItems={appStatic.editFundSourceItems}
            />
            <Spin spinning={isLoading} size="large">
                <Card
                    title={
                        <Title level={4} style={{ color: "#000" }}>
                            {appLabel.generalInfo}
                        </Title>
                    }
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form form={useForm} layout="vertical" onFinish={onSubmit}>
                        <Card
                            style={{
                                marginBottom: "3%",
                                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                            }}
                            bordered
                        >
                            <Row style={{ justifyContent: "space-between" }}>
                                <Form.Item
                                    name="name"
                                    label="name"
                                >
                                    <Input
                                        style={{ width: "30vh" }}
                                    />
                                </Form.Item>
                            </Row>

                        </Card>
                        <Form.Item>
                            <Row>
                                <CustomButton
                                    content="Submit"
                                    style={{
                                        width: "10%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    htmlType="submit"
                                    backgroundColor="#92428B"
                                    colorText="white"
                                    hoverBackground="#AD4EA7"
                                />
                                <CustomButton
                                    content="Cancel"
                                    style={{
                                        width: "10%",
                                        marginLeft: "1%",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    backgroundColor="#fff"
                                    colorText="black"
                                    hoverBackground="#F5F5F5"
                                    onClick={onCancel}
                                />
                            </Row>
                        </Form.Item>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGLA1000);

